import { render, staticRenderFns } from "./FairsListPage.vue?vue&type=template&id=57232668&scoped=true&"
import script from "./FairsListPage.vue?vue&type=script&lang=js&"
export * from "./FairsListPage.vue?vue&type=script&lang=js&"
import style0 from "./FairsListPage.vue?vue&type=style&index=0&id=57232668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57232668",
  null
  
)

export default component.exports